// import "../Users/Users.scss"; // Removed for version update
import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { toast } from "react-toastify";
// import store from "../../../store";
// import { addNewPermission } from "../../../store/actions/permissions";

const ExpandRejectNote = ({ note }) => {
  const closeModal = () => {
    document.getElementById("go-modal").classList.remove("open");
  };

  return (
    <div className="go-modal" id="go-modal">
      <div className="overlay"></div>
      <div className="go-modal-card">
        <a
          className="close-modal"
          onClick={() => {
            closeModal();
          }}
          href="javascript:;"
        >
          <img src="/images/close.svg" />
        </a>
        <div className="go-modal-header">
          <h3 class="fs20 lh-25 metro-m text-d-blue margin-t10">Reject Note</h3>
        </div>
        <div className="go-modal-content">{note}</div>
      </div>
    </div>
  );
};

export default ExpandRejectNote;
